import script from "./InstructionPlanFixPage.vue?vue&type=script&setup=true&lang=js"
export * from "./InstructionPlanFixPage.vue?vue&type=script&setup=true&lang=js"

import "./InstructionPlanFixPage.vue?vue&type=style&index=0&id=e364765a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e364765a"]])

export default __exports__